declare var $:any;
declare var document:any;

const DEV_HOST = 'local-client.well-concepts.com:4447';
const API_SERVER = document.location.host===DEV_HOST?'/api':'';
const TOKEN_STORAGE_KEY = 'token';

export const Transport = {

  DEV_HOST: DEV_HOST,
  API_SERVER: API_SERVER,
  TOKEN_STORAGE_KEY: TOKEN_STORAGE_KEY,

  URL: (url: string, addToken?: boolean) => {
    const beforeToken = addToken && -1 != url.indexOf("?") ? "&" : "?";
    return Transport.API_SERVER + url + (addToken ? beforeToken + "token=" + localStorage.getItem(Transport.TOKEN_STORAGE_KEY) : "");
  },

  internetFailureAlert: (err: string) => {
    alert(err + ' Please make sure that your Internet connection is stable and try again.');
  },

  hasAuthToken: () => {
    return null !== localStorage.getItem(Transport.TOKEN_STORAGE_KEY);
  },

  GET: (url: string, isDelete?: boolean) => new Promise((resolve, reject) => {
    $.ajax(
      {
        dataType: 'json',
        type: (isDelete ? 'DELETE' : 'GET'),
        contentType: 'application/json; charset=utf-8',
        headers: {
          'Authorization': 'Token ' + localStorage.getItem(Transport.TOKEN_STORAGE_KEY)
        },
        url: Transport.URL(url)
      }
    )
      .done((usersData: any) => {
        resolve(usersData);
      })
      .fail((e: any) => {
        reject(e);
      });
  }),


  POST: (url: string, data: any, type?: string) => new Promise((resolve, reject) => {
    $.ajax({
      type: (type ? type : 'POST'),
      url: Transport.URL(url),
      headers: {
        'Authorization': 'Token ' + localStorage.getItem(Transport.TOKEN_STORAGE_KEY)
      },
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(data)
    })
      .done((result: any) => {
        resolve(result ? result : null);
      })
      .fail((result: any, status: any) => {
        const error = result.responseJSON;
        reject(error);
      });
  }),

  PUT: (url: string, data: any) => {
    return Transport.POST(url, data, 'PUT');
  },


  DELETE: (url: string, payload?: any) => {
    if (!payload) {
      return Transport.GET(url, true);
    } else {
      return Transport.POST(url, payload, 'DELETE');
    }
  }


}